import type { DatalayerOutput } from '@analytics/models';
import { InjectionToken, type Type } from '@angular/core';

/**
 * Token that holds all side-effects that can be triggered during the processing of the datalayer stream.
 */
export const DATALAYER_OUTPUTS = new InjectionToken<DatalayerOutput[]>(
  'DATALAYER_OUTPUTS'
);

export function provideDatalayerOutputs(outputs: Type<DatalayerOutput>[]) {
  return {
    provide: DATALAYER_OUTPUTS,
    deps: outputs,
    useFactory: (...instances: DatalayerOutput[]) => instances,
  };
}
